import { render, staticRenderFns } from "./WorkCompanyGeneral.vue?vue&type=template&id=4ad118b0&"
import script from "./WorkCompanyGeneral.vue?vue&type=script&lang=js&"
export * from "./WorkCompanyGeneral.vue?vue&type=script&lang=js&"
import style0 from "./WorkCompanyGeneral.vue?vue&type=style&index=0&id=4ad118b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports